<div class="market-pairs">
  <div class="custom-heading px-2  py-2  d-flex " [ngClass]="{ 'flex-xs-column flex-sm-row flex-md-row flex-lg-row flex-xl-row align-items-xl-center align-items-lg-center align-items-md-center align-items-sm-center align-items-xs-start ': isHeaderRowElementsLayout , 'flex-column align-items-start': !isHeaderRowElementsLayout }">
<div class="d-flex align-items-center">
      <div class="py-2 px-2 text-color-theme text-center" style="font-weight: bold">
      {{"order-book"|translate}}
    </div>
    <div class="p-1 mx-2 client-selection" *ngIf="!acc">
      <select [(ngModel)]="selectedAccount" class="form-select px-2 form-select-sm" (change)="getOrders()">
        <option *ngFor="let acc of accList" value="{{acc.relationCode}}"> ({{acc.relationCode}})
          {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}
        </option>
      </select>
    </div>
    <div *ngIf="isFromProfile" class="my-2">
      <input type="text" class="form-control search-text-color" style="height: 30px; width: 250px; border-radius: 2px"
        (keyup)="updateFilter($event)" placeholder="{{ 'search' | translate }}" />
    </div>
    </div>
    <div *ngIf="!isHeaderRowElementsLayout" class="horizontal-border"></div>
    <div class="market-history" style="border: none; ">
      <ul class="nav nav-pills m-0" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="pill" (click)="setFilter(0)" role="tab" aria-selected="false">
            <h6>{{"all"|translate}}</h6>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-toggle="pill" (click)="setFilter(1)" role="tab" aria-selected="true">
            <h6>{{"completed"|translate}}</h6>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-toggle="pill" (click)="setFilter(2)" role="tab" aria-selected="true">
            <h6>{{"pending"|translate}}</h6>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-toggle="pill" (click)="setFilter(3)" role="tab" aria-selected="true">
            <h6>{{"cancelled"|translate}}</h6>
          </a>
        </li>
        <ul class="align-self-center my-2 mx-2" *ngIf="isFromProfile">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; vertical-align: middle; cursor: pointer" matTooltipPosition="left" [matTooltip]="
              'export-excel' | translate
            " matTooltipClass="custom-tooltip" (click)="exportAsExcel()" class="text-success align-self-center">save_alt</mat-icon>
        </ul>
      </ul>
    </div>
  </div>
  <div class="tab-content">
    <div class="tab-pane fade show active table-custom" id="recent-trades" role="tabpanel">
      <table matSort (matSortChange)="sortData($event)" datatable [dtOptions]="dtOptions"
        class="table table-sm table-dark" *ngIf="!isOrdersLoading && userOrders">
        <thead style="z-index: 100;">
          <tr>
            <th class="fit">{{"status"|translate}}</th>
            <th mat-sort-header="symbol" class="fit">{{ 'symbol' | translate }}</th>
            <th mat-sort-header="order" class="fit">{{"order#"|translate}}</th>
            <th mat-sort-header="last-update" class="fit">{{"last-update"|translate}}</th>
            <th class="fit">{{"transaction" | translate}}</th>
            <th mat-sort-header="remaining-qty" class="fit">{{"remaining-qty"|translate}}</th>
            <th mat-sort-header="qty" class="fit">{{"qty"|translate}}</th>
            <th mat-sort-header="price" class="fit">{{"price"|translate}}</th>
            <th mat-sort-header="order-value" class="fit">{{"order-value-hint"|translate}}</th>
            <th mat-sort-header="currency" class="fit">{{"currency"|translate}}</th>
            <th mat-sort-header="filled" class="fit">{{"filled"|translate}}</th>
            <th class="fit">{{"type"|translate}}</th>
            <th class="fit">{{"duration"|translate}}</th>
            <th class="fit">{{"demand-method" | translate}}</th>
            <th class="fit">{{"source"|translate}}</th>

            <th class="fit no-sort"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of userOrdersData"
            [ngClass]="{flashit: item?.isUpdate==true, selected:(this.selectedOrder?.OrderNumber == item.OrderNumber)}"
            (dblclick)="orderDoubleClicked(item)">
            <td class="fit">
              <div class="filter">
                <span
                class="badge"
                [ngStyle]="{
                  'background-color': getBackgroundColor(item?.FixStatus) || '#ffee32',
                  color: getColor(item?.FixStatus) || 'black'
                }"
              >
                {{
                  translate.currentLang == 'en'
                    ? (item?.FixStatusEn || 'sending')
                    : (item?.FixStatusAr || 'جاري الارسال')
                }}
              </span>
                <span *ngIf="item?.Remark == 'OPR'" class="badge bg-info text-dark mx-1">
                  {{'IPO' | translate}}
                </span>
                <span *ngIf="item?.OrderStatus == 7" class="badge bg-warning text-dark mx-1">
                  {{'fIXAwaitUpdate' | translate}}
                </span>
                <span *ngIf="item?.OrderStatus == 9 " class="badge bg-warning text-dark mx-1">
                  {{'fIXAwaitCancel' | translate}}
                </span>
                <span *ngIf="item?.OrderStatus == 11 " class="badge bg-warning text-dark mx-1">
                  {{'fIXAwaitSuspend' | translate}}
                </span>
                <span *ngIf="item?.IsSuspended" class="badge bg-warning text-dark mx-1">
                  {{ "suspended" | translate }}
                </span>
                <span *ngIf="item?.IsSuspendAwaitApproval && item?.OrderStatus != 24" class="badge bg-warning text-dark mx-1">
                  {{ "suspended-await-approval" | translate }}
                </span>
                <span *ngIf="isWaitingMSCD(item)" class="badge bg-warning text-dark mx-1">
                  {{ "waiting-mscd" | translate }}
                </span>
                <i class="fas fa-filter custom-text-warning p-0 mx-7"
                  (click)="this.filter.fixStatus = item.FixStatus; setFilter(filter)"></i>
              </div>
            </td>
            <td class="padding-start ">
              {{(translate.currentLang=='en')?item.SymbolNameEn:item.SymbolNameAr}}
            </td>
            <!-- <td class="fit">{{(translate.currentLang=='en')?item.SymbolNameEn:item.SymbolNameAr}}</td> -->
            <td class="position-relative"> <span *ngIf="this.accService.quickButton == true" class="position">
                <i (click)='updateOrder(item)' *ngIf="this.CanBeFIXUpdated(item) && item?.Remark != 'OPR' && item.MarketCode != 'FUND'"
                  class="fas fa-pen-to-square icon-edit-color p-0 mx-7" ></i>
                <i (click)="cloneOrder(item?.OrgQty, item?.OrgPrice, item?.SymbolCode, item?.TransactionId)" *ngIf="item?.Remark != 'OPR' && item.MarketCode != 'FUND'"
                  class="fas fa-copy info-warning p-0 mx-7"></i>
                <i *ngIf="this.CanBeFIXUpdated(item)" (click)='deleteOrder(item)'
                  class="fas fa-trash text-danger mx-7"></i>
                <i (click)="viewOrder(item.OrderNumber)" class="fas fa-clock-rotate-left text-cyan p-0 mx-7"></i>
              </span><span class="orderNumber">{{item.OrderNumber}}</span></td>
            <!-- <td class="fit">(item.lastUpdateDate == null)?{{item.CreateDate| date:'medium'}}:{{item.LastUpdateDate| date:'medium'}}</td> -->
            <td class="fit" *ngIf="item.lastUpdateDate == null">{{item.CreateDate| date:'medium'}}</td>
            <td class="fit" *ngIf="item.lastUpdateDate != null">{{item.LastUpdateDate| date:'medium'}}</td>

            <td [ngClass]="item.TransactionId==1 ? 'green' : 'red'">
              {{translate.currentLang=='en'?item.TransactionTypeEn:item.TransactionTypeAr}}
            </td>

            <td class="fit">{{remainingQty(item)}}</td>

            <td>{{item.OrgQty}}</td>
            <td>{{item.OrgPrice}}</td>
            <td>{{((item.OrgQty || 0) * (item.OrgPrice || 0)) | number}}</td>
            <td>{{getCurrencyAbbreviation(item)}}</td>
            <td>{{item.TradedQty}}</td>
            <td
              [ngStyle]="isDarkTheme?item.IsMarketPrice?{'color': 'darkturquoise'} : {'color': 'lightgrey'}:item.IsMarketPrice?{'color': 'darkturquoise'} : {'color': 'grey'}">
              {{(item.IsMarketPrice)?("market-price"| translate):("limit-price" | translate)}}
            </td>
            <td class="fit">
              {{getTiffFlag(item.TiffFlag)}}
              <span *ngIf="item.TiffFlag==6 && item.TiffDate!=null"> -
                {{item.TiffDate | date:'d/M/yyyy'}}</span>
            </td>
            <td>{{demandEnum(item.DemandMethod)}}</td>
            <td>{{(item.Origin ==1)?'OMS':'Online'}}</td>

            <!-- <td style="font-size:small" class="fit">{{translate.currentLang=='en'?item.FixStatusEn:item.FixStatusAr}}</td> -->
            <td class="p-0 fit">
              <div class="btn-group">
                <button [disabled]="!CanBeFIXUpdated(item)" class="btn btn-tab btn-sm dropdown-toggle" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{'actions'|translate}}
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" (click)='updateOrder(item)'
                    *ngIf="CanBeFIXUpdated(item) && item?.Remark != 'OPR'&& item.MarketCode != 'FUND'">{{'update'|translate}}</a>
                  <a class="dropdown-item"
                    (click)="cloneOrder(item?.OrgQty, item?.OrgPrice, item?.SymbolCode, item?.TransactionId)"
                    *ngIf="CanBeFIXUpdated(item)&& item?.Remark != 'OPR'&& item.MarketCode != 'FUND'">{{ "clone" |
                    translate }}</a>
                  <a class="dropdown-item" (click)='deleteOrder(item)'
                    *ngIf="CanBeFIXUpdated(item)">{{'cancel'|translate}}</a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="d-flex justify-content-center" *ngIf="isOrdersLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </table>
      <table class="d-flex h-100 justify-content-center table-custom" *ngIf="!isOrdersLoading && !userOrders">
        <div class="row no-data m-3">
          <div class="col-md-12">
            <i class="icon ion-md-briefcase"></i>
            <div class="col-sm-12">
              <h6 class="nodata-msg">{{'no-order'|translate}}</h6>
            </div>
            <div class="col-md-12">
              <button class="btn btn-sm btn-primary br-radius" (click)="newOrder()">
                {{'new-order'|translate}}
              </button>
            </div>
          </div>
        </div>
      </table>
    </div>
  </div>
</div>
<ngx-loading
  [show]="isRequestLoading"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>